/**
 * AsiSuena — el preview "Así suena" en versión compacta, pensado para ir PEGADO arriba de la
 * barra de navegación mientras se configura la voz y la oferta.
 *
 * El mensaje sale del generador real (ver useEnsayoVoz): es exactamente lo que recibe el cliente.
 * Acá sólo se muestra —el desglose "¿por qué dice eso?" queda en el paso "Tu voz"—, para que el
 * bloque sea bajo y no le coma la pantalla al formulario que está arriba.
 */

import { Sparkles, Loader2, AlertTriangle } from "lucide-react";
import type { EnsayoVoz } from "../hooks/useEnsayoVoz";

export default function AsiSuena({ ensayo, cargando }: { ensayo: EnsayoVoz | null; cargando: boolean }) {
  const tieneProhibidas = !!ensayo?.prohibidasEncontradas?.length;
  return (
    <div className="rounded-xl border border-slate-200 bg-white/70 px-3 py-2.5">
      <div className="flex items-center justify-between mb-1.5">
        <p className="text-[11px] font-bold uppercase tracking-wider text-slate-500 flex items-center gap-1.5">
          <Sparkles size={12} className="text-violet-500" /> Así suena
          {/* que se note que el ejemplo se está recalculando con lo que acabás de tocar */}
          {cargando && <Loader2 size={11} className="animate-spin text-slate-400" />}
        </p>
        {ensayo && <span className="text-[10px] text-slate-400 tabular-nums">{ensayo.caracteres} caracteres</span>}
      </div>
      <div className="rounded-lg bg-[#e7ffdb] px-3 py-2 text-[13px] text-slate-800 leading-snug whitespace-pre-wrap break-words">
        {cargando && !ensayo
          ? <span className="text-slate-400 inline-flex items-center gap-1.5"><Loader2 size={12} className="animate-spin" /> armando…</span>
          : (ensayo?.mensaje || "—")}
      </div>
      {/* el mismo guardrail que en el paso Tu voz: si el mensaje usa una palabra prohibida, se
          avisa acá también, porque acá es donde el mensaje está a la vista al configurar */}
      {tieneProhibidas && (
        <p className="text-[11px] text-amber-700 bg-amber-50 rounded-lg px-2 py-1.5 mt-1.5 flex items-start gap-1.5">
          <AlertTriangle size={12} className="flex-shrink-0 mt-0.5" />
          Usa {ensayo!.prohibidasEncontradas.map((p) => `“${p}”`).join(", ")}, que pediste no usar. No vas a poder enviar hasta cambiarlo.
        </p>
      )}
    </div>
  );
}
